import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const apiCall = (
  url,
  data,
  headers,
  method,
  responseType = "json",
  onDownloadProgress
) =>
  axios({
    method,
    url: API_URL + url,
    data,
    headers,
    responseType,
    onDownloadProgress: (progressEvent) => {
      if (onDownloadProgress) {
        const total = progressEvent.total;
        const loaded = progressEvent.loaded;
        onDownloadProgress(loaded, total);
      }
    },
  });
